
  <div class="flex-row ml-perc-1 mt-perc-1">
  <sh-breadcrumbs>
    <sh-breadcrumb-item label='Home' (keydown)="onRouteChange('/')" (click)="onRouteChange('/')"></sh-breadcrumb-item>
    <sh-breadcrumb-item [label]='(isManageTemplatePage ? "allQueryTable.manageTemplatesLabel" : "allQueryTable.viewQueriesLabel") | translate'></sh-breadcrumb-item>
  </sh-breadcrumbs>
</div>
<div class="project-container">
  <sh-card>
    <div *ngIf="isLoading && activeFilterTab !== 'configure'" class="state-container">
      <sh-spinner></sh-spinner>
    </div>
    <div *ngIf="activeFilterTab === 'configure'; else filters">
      <app-configure-columns [notification]="notification" (notificationChange)="onNotificationChange($event)"></app-configure-columns>
    </div>
    <ng-template #reusableTable let-isModal="isModal">
    <div *ngIf="!isLoading" class="card-header-with-search">

      <div class="header-title-row">
        <sh-text size="header-1">
          {{ (isManageTemplatePage ? 'allQueryTable.manageTemplatesLabel' : 'allQueryTable.viewQueriesLabel') | translate }}
        </sh-text>
      </div>

      <sh-divider class="header-divider"></sh-divider>

      <div class="search-row">
        <sh-search class="ngPrimeSearchIcon search-input"
          [id]="'tt-search-' + (isModal ? 'm' : 'p')"
          no-border
          (input)="onSearchInput($event)"
          (clearsearch)="onSearchClear($event)"
          [label]="(isManageTemplatePage ? 'allQueryTable.searchByNameTemplateId' : 'allQueryTable.searchByNameQueryProjectId') | translate">
        </sh-search>
        <sh-tooltip delay [target]="'tt-search-' + (isModal ? 'm' : 'p')" [label]="(isManageTemplatePage ? 'allQueryTable.tooltip.searchTemplate' : 'allQueryTable.tooltip.searchQuery') | translate" placement="bottom" variation="long"></sh-tooltip>
        <sh-button
          [id]="'tt-searchall-' + (isModal ? 'm' : 'p')"
          size="auto"
          label="Search All"
          [disabled]="isOthersSearchLoading || !searchValue.trim() || isShowingOthersResults"
          (click)="onSearchOthers()"
          (keydown)="onSearchOthers()">
        </sh-button>
        <sh-tooltip delay [target]="'tt-searchall-' + (isModal ? 'm' : 'p')" [label]="'allQueryTable.tooltip.searchAll' | translate" placement="bottom" variation="long"></sh-tooltip>
      </div>

      <div class="summary-row">
        <sh-text size="body-2" class="total-count">
          <strong>Showing</strong> {{ isManageTemplatePage ? 'Templates:' : 'Queries:' }}
          <strong>({{ processedQueries.length }})</strong>
        </sh-text>

        <div class="header-icons">
          <sh-icon *ngIf="selectedQueries.length > 0" button size="m" icon="delete" (click)="deleteSelectedQueries()" (keydown)="deleteSelectedQueries()"></sh-icon>

          <ng-container>
            <sh-icon icon="layout-3x1" button color="black" size="m" id="target-2a" (click)="toggleColumnVisibilityPopup()" (keydown)="toggleColumnVisibilityPopup()"></sh-icon>
            <sh-popover sticky [visible]="showColumnVisibilityPopup" target="target-2a" label="Choose Columns"
              modal-height='20vh' modal-width='20vw' style="z-index: 103;">
              <ul style="list-style-type: none;">
                <li *ngFor="let column of tableHeaders">
                  <label>
                    <sh-checkbox [active]="column.visible"
                      (checked)="onColumnVisibilityChange(column, $event)" />
                    {{ column.displayName }}
                  </label>
                </li>
              </ul>
              <sh-button label="Close" slot='footer' color="Tertiary" size="auto"
                [id]="'tt-closecols-' + (isModal ? 'm' : 'p')"
                (click)="toggleColumnVisibilityPopup()"></sh-button>
            </sh-popover>
            <sh-tooltip delay target="target-2a" [label]="'allQueryTable.tooltip.chooseColumns' | translate" placement="top" variation="long"></sh-tooltip>
            <sh-tooltip delay [target]="'tt-closecols-' + (isModal ? 'm' : 'p')" [label]="'allQueryTable.tooltip.closeColumns' | translate" placement="top" variation="short"></sh-tooltip>
          </ng-container>

          <sh-icon [id]="'tt-expand-' + (isModal ? 'm' : 'p')" [icon]="expandtableModal ? 'exit-fullscreen' : 'fullscreen'" button size="m" (click)="openExpandModal()" (keydown)="openExpandModal()"></sh-icon>
          <sh-tooltip delay [target]="'tt-expand-' + (isModal ? 'm' : 'p')" [label]="(expandtableModal ? 'allQueryTable.tooltip.collapse' : 'allQueryTable.tooltip.expand') | translate" placement="top" variation="short"></sh-tooltip>
        </div>
      </div>


    </div>

     <!-- Others Search Banner -->
      <div *ngIf="isShowingOthersResults"
      style="display: flex; align-items: center; gap: 8px; padding: 6px 12px; background-color: #e8f4fd; border-left: 3px solid #006ADD; margin-bottom: 4px; margin-top: 2px;">
      <sh-icon icon="information" size="s" color="primary"></sh-icon>
      <sh-text size="body-2">
        Showing {{ isManageTemplatePage ? 'template' : 'query' }} results from other users for 
        "<strong>{{ searchValue }}</strong>"
      </sh-text>
    </div>

    <p-table #dt1 *ngIf="!isLoading" [value]="paginatedQueries" [tableStyle]="{'min-width': '50rem'}" [globalFilterFields]="['name','type', 'createdOnFormatted', 'updatedOnFormatted']" [scrollable]="true" [scrollHeight]="getTableScrollHeight()"
      [reorderableColumns]="true"
      [scrollable]="showAll"
      [customSort]="true"
      (onSort)="onSort($event)"
      (onColReorder)="onColumnReorder($event)">

      <ng-template pTemplate="header">
        <tr>
          <th></th>
          <th *ngFor="let header of visibleTableHeaders; let i = index" pReorderableColumn
            [pSortableColumn]="header.isSortable !== false ? header.colName : undefined">
            <div class="column-header-content">
              <div class="column-title-sort" [id]="'tt-sort-' + (isModal ? 'm' : 'p') + '-' + i">
                {{ header.displayName }}                
                <p-sortIcon *ngIf="header.isSortable !== false" [field]="header.colName"></p-sortIcon>
              </div>
            </div>
          </th>
        </tr>
        <tr *ngIf="hasFilterableColumns">
          <th></th>
          <th *ngFor="let header of visibleTableHeaders; let i = index">
            <sh-dropdown *ngIf="header.filterType === 'select'"
              [id]="'tt-colfilter-' + (isModal ? 'm' : 'p') + '-' + i"
              [ngClass]="{ 'compact-template-filter': isManageTemplatePage && header.colName === 'type' }"
              [label]="'All'" condensed
              [(ngModel)]="columnFilters[header.colName]"
              (ngModelChange)="onColumnFilterChange()"
              (click)="$event.stopPropagation()">
              <sh-menu-item label="All" [value]="''"></sh-menu-item>
              <sh-menu-item *ngFor="let option of getColumnFilterOptions(header.colName)" [label]="option" [value]="option"></sh-menu-item>
            </sh-dropdown>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-query let-i="rowIndex">
        <tr  (dblclick)="routeToSelectedQuery(query)">
           <td>
          <sh-checkbox 
            *ngIf="query.type === QueryType.Standard && query.email === dataService.profile.mail" 
            [id]="'tt-rowcheck-' + (isModal ? 'm' : 'p') + '-' + i"
            [active]="isQuerySelected(query)"
            (checked)="onRowCheckboxChange(query)">
          </sh-checkbox>
          <sh-tooltip *ngIf="query.type === QueryType.Standard && query.email === dataService.profile.mail" delay [target]="'tt-rowcheck-' + (isModal ? 'm' : 'p') + '-' + i" [label]="'allQueryTable.tooltip.rowCheckbox' | translate" placement="top" variation="long"></sh-tooltip>
        </td>
          <ng-container *ngFor="let header of visibleTableHeaders">
            <td *ngIf="header.colName === 'id'">{{ query.id }}</td>
            <td *ngIf="header.colName === 'isFavourite'" class="favorite-cell">
              <ng-container *ngIf="query.isFavourite; else nonFavoriteIcon">
                <div class="favorite-icon-wrapper">
                  <sh-icon class="favorite-icon-default" icon="favorite" size="s" color="primary" (click)="onToggleFavorite(false, query)"></sh-icon>
                </div>
              </ng-container>
              <ng-template #nonFavoriteIcon>
                <sh-icon class="favorite-icon-hover" icon="favorite-off" size="s" color="primary" (click)="onToggleFavorite(true, query )"></sh-icon>
              </ng-template>
            </td>
            <td *ngIf="header.colName === 'name'">
              <a (click)="routeToSelectedQuery(query)"
                style="color: var(--support-5, #006ADD); cursor: pointer;">{{ query.name }}</a>
            </td>
            <td *ngIf="header.colName === 'createdOn'">{{ query.createdOnFormatted }}</td>
            <td *ngIf="header.colName === 'updatedon'">{{ query.updatedOnFormatted }}</td>
            <td *ngIf="header.colName === 'createdBy'">{{ query.email }}</td>
            <td *ngIf="header.colName === 'type'">
              <sh-badge [label]="getTypeLabel(query.type)" size="medium" [attr.neutral]="query.type === QueryType.Template ? '' : null">
              </sh-badge>
            </td>
            <td *ngIf="header.colName === 'comments'">
              <span [id]="'comment-' + i">
                {{ query.comments && query.comments.length > 15
                    ? (query.comments | slice:0:15) + '...'
                    : query.comments }}
              </span>
              <sh-tooltip
                *ngIf="query.comments && query.comments.length > 15"
                [target]="'comment-' + i"
                [label]="query.comments"
                placement="top"
                variation="long">
              </sh-tooltip>
            </td>
            <td *ngIf="header.colName === 'action'">
              <!-- Hide action menu for other users' results -->
              <sh-icon
                *ngIf="canManageQuery(query)"
                size="s"
                icon='more'
                [id]="'target-' + i"
                (click)="toggleMoreVisibilityPopup(query)"
                (keydown)="toggleMoreVisibilityPopup(query)">
              </sh-icon>
              <sh-tooltip *ngIf="canManageQuery(query)" delay [target]="'target-' + i" [label]="(isManageTemplatePage ? 'allQueryTable.tooltip.actionTemplate' : 'allQueryTable.tooltip.actionQuery') | translate" placement="top" variation="short"></sh-tooltip>
            </td>
            <td *ngIf="header.colName === 'projectId'">{{ query.projectId }}</td>
            <td *ngIf="header.colName === 'isDefault'">
              <sh-radio-button label=""
                [id]="'tt-default-' + (isModal ? 'm' : 'p') + '-' + i"
                *ngIf="(query.type === QueryType.Template || query.type === QueryType.Public_Template) && query.email === dataService.profile.mail"
                [active]="defaultQueryGuid === query.guid"
                (active-changed)="onSetDefaultQuery(query,$event)">
              </sh-radio-button>
              <sh-tooltip *ngIf="(query.type === QueryType.Template || query.type === QueryType.Public_Template) && query.email === dataService.profile.mail" delay [target]="'tt-default-' + (isModal ? 'm' : 'p') + '-' + i" [label]="'allQueryTable.tooltip.defaultRadio' | translate" placement="top" variation="long"></sh-tooltip>
            </td>
          </ng-container>

          <sh-popover
            [visible]="showMoreVisibilityPopup && selectedQuery?.guid === query.guid"
            [target]="'target-' + i"
            placement="top-end"
            modal-height='50px'
            modal-width='30px'
            style="z-index: 103;">
            <ng-container *ngIf="query.type === QueryType.Standard && canManageQuery(query)">
              <sh-menu-item label="Rename" (click)="openRenameModal()"></sh-menu-item>
              <sh-divider></sh-divider>
              <sh-menu-item label="Delete" (click)="openDeleteConfirmModal()" (keydown)="openDeleteConfirmModal()"></sh-menu-item>
              <sh-divider></sh-divider>
            </ng-container>
            <ng-container *ngIf="query.type === QueryType.Public_Template && query.email === dataService.profile.mail">
              <sh-menu-item label="Delete" (click)="openDeleteConfirmModal()" (keydown)="openDeleteConfirmModal()"></sh-menu-item>
              <sh-divider></sh-divider>
            </ng-container>
             <ng-container *ngIf="query.type === QueryType.Template  && canManageQuery(query)">
              <sh-menu-item label="Delete" (click)="openDeleteConfirmModal()" (keydown)="openDeleteConfirmModal()"></sh-menu-item>
              <sh-divider></sh-divider>
            </ng-container>
            <sh-menu-item *ngIf="canManageQuery(query)" label="Edit Comment" (click)="openEditCommentModal()"></sh-menu-item>
          </sh-popover>
        </tr>
      </ng-template>

      <!-- No Results / Loading Empty State -->
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="visibleTableHeaders.length + 1">
            <!-- Loading Spinner -->
           <div *ngIf="isOthersSearchLoading" class="empty-state-container">
              <sh-spinner size="m"></sh-spinner>
              <sh-text size="body-2">
                Searching {{ isManageTemplatePage ? 'templates' : 'queries' }} from other users...
              </sh-text>
            </div>

            <!-- No Results State -->
             <div *ngIf="!isOthersSearchLoading" class="empty-state-container">
              <sh-icon icon="search" size="l"></sh-icon>
              <sh-text size="body-1" *ngIf="isShowingOthersResults">
                No {{ isManageTemplatePage ? 'templates' : 'queries' }} found for 
                "<strong>{{ searchValue }}</strong>" from other users.
              </sh-text>
              <sh-text size="body-1" *ngIf="!isShowingOthersResults">
                No records found.
              </sh-text>
            </div>
          </td>
        </tr>
      </ng-template>

    </p-table>

    <!-- Pagination -->
    <div class="pagination-container">
      <sh-pagination
        *ngIf="!showAll && processedQueries.length > pageSize"
        [id]="'tt-pagination-' + (isModal ? 'm' : 'p')"
        [pages]="getTotalPages()"
        [current-page]="pageIndex"
        #shPagination
        (previous-page-move)="loadPreviousPage($event)"
        (next-page-move)="loadNextPage($event)"
        (clicked-page-move)="loadSelectedPage($event)"
        class="pagination-row">
      </sh-pagination>
      <sh-tooltip *ngIf="!showAll && processedQueries.length > pageSize" delay [target]="'tt-pagination-' + (isModal ? 'm' : 'p')" [label]="'allQueryTable.tooltip.pagination' | translate" placement="top" variation="long"></sh-tooltip>

      <sh-dropdown
        *ngIf="queries.length > 0"
        [id]="'tt-pagesize-' + (isModal ? 'm' : 'p')"
        [value]="showAll ? 'All' : pageSize"
        condensed
        label=""
        (value-changed)="pagePerRow($event)"
        class="page-size-dropdown">
        <sh-menu-item *ngFor="let option of pageSizeOptions" [label]="option"></sh-menu-item>
      </sh-dropdown>
      <sh-tooltip *ngIf="queries.length > 0" delay [target]="'tt-pagesize-' + (isModal ? 'm' : 'p')" [label]="'allQueryTable.tooltip.pageSize' | translate" placement="bottom" variation="long"></sh-tooltip>
    </div>

    </ng-template>
    <ng-template #filters>
      <div *ngIf="!expandtableModal">
        <ng-container *ngTemplateOutlet="reusableTable; context: { isModal: false }"></ng-container>
      </div> 
    </ng-template>
  </sh-card>
</div>
<sh-modal [visible]="showRenameModal" [label]="'allQueryTable.renameModalLabel' | translate" modal-height='210px' modal-width='320px' style="z-index: 105;" (modal-closed)="closeRenameModal()">
  <sh-input-text 
        id="tt-rename-input"
        class="rename-query-input"
        type="text" 
        condensed
        [(ngModel)]="newQueryName" 
        (input)="onRenameRestrict($event)"
        [error]="!!renameNameError"
        maxlength="25"></sh-input-text>
  <sh-tooltip delay target="tt-rename-input" [label]="'allQueryTable.tooltip.renameInput' | translate" placement="bottom" variation="long"></sh-tooltip>
  <div *ngIf="renameNameError" class="rename-error-message">{{ renameNameError }}</div>
  <sh-button
    id="tt-rename-cancel"
    color='secondary'
    slot='footer'
    [label]="'allQueryTable.cancelButton' | translate"
    (click)="closeRenameModal()"
  ></sh-button>
  <sh-tooltip delay target="tt-rename-cancel" [label]="'allQueryTable.tooltip.renameCancel' | translate" placement="top" variation="short"></sh-tooltip>
  <sh-button
    id="tt-rename-save"
    slot='footer'
    [disabled]="!!renameNameError || !newQueryName.trim() || isSaving"
    [label]="isSaving ? ('allQueryTable.savingButton' | translate) : ('allQueryTable.saveButton' | translate)"
    (click)="saveNewName()"
  ></sh-button>
  <sh-tooltip delay target="tt-rename-save" [label]="'allQueryTable.tooltip.renameSave' | translate" placement="top" variation="short"></sh-tooltip>
</sh-modal>

<!-- ...existing code... -->

<sh-modal [visible]="showDeleteConfirmModal" [label]="'allQueryTable.deleteModalLabel' | translate" modal-height='210px' modal-width='350px' style="z-index: 105;" (modal-closed)="closeDeleteConfirmModal()">

  <!-- Single query/template delete -->
  <ng-container *ngIf="selectedQuery && selectedQueries.length === 0">
    <sh-text size="body-1">
      Are you sure you want to delete this 
      {{ selectedQuery.type === QueryType.Standard ? 'query' : 'template' }}?
    </sh-text>
    <sh-text size="body-2" class="delete-warning">
      This will permanently remove the 
      {{ selectedQuery.type === QueryType.Standard ? 'query' : 'template' }} 
      and <strong>all versions</strong> associated with it.
    </sh-text>
  </ng-container>

  <!-- Bulk delete -->
  <ng-container *ngIf="selectedQueries.length > 0">
    <sh-text size="body-1">
      Are you sure you want to delete {{ selectedQueries.length }} selected 
      {{ selectedQueries[0].type === QueryType.Standard ? 'queries' : 'templates' }}?
    </sh-text>
    <sh-text size="body-2" class="delete-warning">
      This will permanently remove all selected 
      {{ selectedQueries[0].type === QueryType.Standard ? 'queries' : 'templates' }} 
      and <strong>all versions</strong> associated with them.
    </sh-text>
  </ng-container>

  <sh-button
    id="tt-delete-cancel"
    color='secondary'
    slot='footer'
    [label]="'allQueryTable.cancelButton' | translate"
    (keydown)="closeDeleteConfirmModal()"
    (click)="closeDeleteConfirmModal()"
    [disabled]="isSaving">
  </sh-button>
  <sh-tooltip delay target="tt-delete-cancel" [label]="'allQueryTable.tooltip.deleteCancel' | translate" placement="top" variation="short"></sh-tooltip>
  <sh-button
    id="tt-delete-confirm"
    slot='footer'
    [label]="isSaving ? 'Deleting...' : ('allQueryTable.yesButton' | translate)"
    (keydown)="deleteQuery()"
    (click)="deleteQuery()"
    [disabled]="isSaving">
  </sh-button>
  <sh-tooltip delay target="tt-delete-confirm" [label]="'allQueryTable.tooltip.deleteConfirm' | translate" placement="top" variation="long"></sh-tooltip>

</sh-modal>


<app-notification [notification]="notification"></app-notification>
<sh-modal [visible]="editCommentModal" [label]="'allQueryTable.editCommentModalLabel' | translate" modal-height='370px' modal-width='450px' style="z-index: 105;" (modal-closed)="closeEditCommentModal()">
  <sh-input-text
          id="tt-editcomment-input"
          ngDefaultControl
          condensed
          style="margin-top: 2%"
          textarea
          rows="10"
          label="Comments"
          [(ngModel)]="commentText"
          (ngModelChange)="onCommentTextChange(commentText)"
          >
  </sh-input-text>
  <sh-tooltip delay target="tt-editcomment-input" [label]="'allQueryTable.tooltip.editCommentInput' | translate" placement="top" variation="long"></sh-tooltip>
  <div *ngIf="commentError" style="color: red; font-size: 12px; margin-top: 4px;">
    {{ commentError }}
  </div>
  <sh-button
    id="tt-editcomment-cancel"
    color='secondary'
    slot='footer'
    [label]="'allQueryTable.cancelButton' | translate"
    (click)="closeEditCommentModal()"
  ></sh-button>
  <sh-tooltip delay target="tt-editcomment-cancel" [label]="'allQueryTable.tooltip.editCommentCancel' | translate" placement="top" variation="short"></sh-tooltip>
  <sh-button
    id="tt-editcomment-save"
    slot='footer'
    [disabled]="!!commentError || isSaving"
    [label]="isSaving ? ('allQueryTable.savingButton' | translate) : ('allQueryTable.saveButton' | translate)"
    (click)="saveUpdatedComment()"
    (keydown)="saveUpdatedComment()"
  ></sh-button>
  <sh-tooltip delay target="tt-editcomment-save" [label]="'allQueryTable.tooltip.editCommentSave' | translate" placement="top" variation="short"></sh-tooltip>
</sh-modal>
<sh-modal class="expand-table-modal" [visible]="expandtableModal" [label]="(activeFilterTab === 'filter' ? 'allQueryTable.expandTableLabel' : 'allQueryTable.templatesLabel') | translate" modal-height='90vh' modal-width='95vw' (modal-closed)="closeExpandModal()">
  <ng-container *ngTemplateOutlet="reusableTable; context: { isModal: true }"></ng-container>
</sh-modal>

<!-- Set Default Confirmation Modal -->
<sh-modal 
  [visible]="showSetDefaultModal" 
  label="Set template as default"
  modal-height='200px' 
  modal-width='420px' 
  style="z-index: 106;" 
  (modal-closed)="closeSetDefaultModal()">

  <sh-text size="body-1">
    This will be used automatically whenever you create a new template.
  </sh-text>

  <sh-button 
    id="tt-setdefault-cancel"
    slot="footer"
    color="secondary" 
    label="Cancel" 
    (click)="closeSetDefaultModal()"
    [disabled]="isSaving">
  </sh-button>
  <sh-tooltip delay target="tt-setdefault-cancel" [label]="'allQueryTable.tooltip.setDefaultCancel' | translate" placement="top" variation="short"></sh-tooltip>
  <sh-button 
    id="tt-setdefault-confirm"
    slot="footer"
    size="auto"
    label="Set as Default" 
    (click)="confirmSetDefault()"
    [disabled]="isSaving">
  </sh-button>
  <sh-tooltip delay target="tt-setdefault-confirm" [label]="'allQueryTable.tooltip.setDefaultConfirm' | translate" placement="top" variation="long"></sh-tooltip>

</sh-modal>


